import { siteInfo } from '@/mocks/anime';

interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.href ? `${siteInfo.url}${item.href}` : siteInfo.url,
        name: item.name,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600">
        <ol className="flex items-center flex-wrap gap-1">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-2 text-foreground-400" aria-hidden="true">/</span>
              )}
              {item.href ? (
                <a href={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.name}
                </a>
              ) : (
                <span className="text-foreground-950 font-medium whitespace-nowrap">{item.name}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}